import { Button, Dialog } from '@material-ui/core';
import React, { useState } from 'react';
import { PaperComponent } from '../DraggablePaper';
import { NewIcon } from '../icons/Icons';
import { IconWithTooltip } from '../icons/IconWithTooltip';

export function NewObjectButton({ newObjectLabel, dialogContent, refreshState, dialogSize, icon }) {
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleDialogOpen = () => {
        setDialogOpen(true);
    }

    const handleDialogClose = (event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            // Set 'open' to false, however you would do that with your particular code.
            console.log("close");
            setDialogOpen(false);
        }
    }

    return (
        <>
            <Button onClick={handleDialogOpen}>
                <IconWithTooltip title={newObjectLabel} >
                    {icon ? icon : <NewIcon />}
                </IconWithTooltip>
            </Button>
            <Dialog
                disableScrollLock
                PaperComponent={PaperComponent}
                maxWidth={dialogSize ? dialogSize : "sm"}
                open={dialogOpen}
                onClose={handleDialogClose}
                aria-labelledby="form-dialog-title">
                <div className="modal-form">
                    <button className="close-modal-btn lnr-cross" onClick={handleDialogClose}></button>
                    <h2 id="draggable-dialog-title">{newObjectLabel}</h2>
                    {dialogContent(refreshState, () => handleDialogClose())}
                </div>

            </Dialog>
        </>
    )
}